import { useEffect, useState } from 'react';

// 简单响应式断点：调高到 992，兼容 iOS Safari/刘海安全区/横屏等场景
const MOBILE_MAX_WIDTH = 992;

export default function useResponsive() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener ? mq.addEventListener('change', update) : mq.addListener(update);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', update) : mq.removeListener(update);
    };
  }, []);

  return { isMobile };
}


